import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslationKey } from '@shared/translations/auto-generated/translation-key';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { LinkComponent } from '@shared/routing/link/link.component';
import { KeyValuePipe, NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-footer-social-group',
    templateUrl: './footer-social-group.component.html',
    styleUrls: ['./footer-social-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, NgIf, LinkComponent, SvgIconComponent, KeyValuePipe, TranslateSafePipe]
})
export class FooterSocialGroupComponent {
    public propertyMap = {
        linkInstagram: { icon: 'instagram', translation: 'footer.socialLinkInstagramText' },
        linkFacebook: { icon: 'facebook', translation: 'footer.socialLinkFacebookText' },
        linkLinkedin: { icon: 'linkedin', translation: 'footer.socialLinkLinkedInText' },
        linkYoutube: { icon: 'youtube', translation: 'footer.socialLinkYoutubeText' }
    } as GenericObject<{ icon: string; translation: TranslationKey }>;

    @Input()
    public readonly links: Record<string, string | undefined>;
}
